import {useSelector} from 'react-redux';

import {ICC_SSO_AD_DEEPLINK_TEMPLATE} from '@/consts/icc/iccSsoDeeplinkTemplates';
import useSsoLink from '@/hooks/sso/useSsoLink';
import useForwardToUsbRequiredPage from '@/hooks/useForwardToUsbRequiredPage';
import userBrowserService from '@/services/user/userBrowserService';
import {selectDeviceSerialNumber, selectDeviceType} from '@/state/selectors/device';

const useRedirectToPhase2 = ({disabled} = {}) => {
    const deviceType = useSelector(selectDeviceType);
    const deviceSerialNumber = useSelector(selectDeviceSerialNumber);
    const isIosDevice = userBrowserService.isIosDevice();
    const {isUsbPageRequired, redirect: redirectToUsbPage} = useForwardToUsbRequiredPage({deviceType});
    const {redirect: redirectToPhase2} = useSsoLink({
        ssoTemplate: ICC_SSO_AD_DEEPLINK_TEMPLATE,
        ssoParams: {
            deviceType,
        },
        disabled,
        deviceType,
        deviceSerialNumber,
        openInBluefy: isIosDevice,
    });

    if (isUsbPageRequired) {
        return redirectToUsbPage;
    }

    return redirectToPhase2;
};

export default useRedirectToPhase2;
